import {
    Component,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    SimpleChanges
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { fromPatterns } from '../../store/patterns.selectors';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { changeDetailHeader } from '../../store/actions/patterns.action';
import { PatternsState } from '../../store/patterns.reducer';
import { HeaderItem, headerItemComparer } from '../../../layout/interfaces/header-item';

@Component({
    selector: 'app-pattern-toolbar-form',
    templateUrl: './pattern-toolbar-form.component.html',
    styleUrls: ['./pattern-toolbar-form.component.scss']
})
export class PatternToolbarFormComponent implements OnInit, OnChanges, OnDestroy {
    @Input() creating = false;
    @Input() ableToEdit = false;

    editing = false;

    patternHeaderItem$: Observable<HeaderItem | null>;
    onDestroy$ = new Subject<void>();

    headerItem: HeaderItem | null = null;
    headerForm: FormGroup = this.formBuilder.group({
        name: ['', Validators.required],
        description: ['']
    });

    constructor(private store: Store<PatternsState>, private formBuilder: FormBuilder) {
        this.patternHeaderItem$ = this.store.select(fromPatterns.selectHeader);
    }

    ngOnInit(): void {
        this.headerForm.valueChanges
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((item: HeaderItem) => {
                const changes =
                    item.name != this.headerItem?.name ||
                    item.description != this.headerItem.description;
                if (!changes) return;
                this.store.dispatch(
                    changeDetailHeader({
                        patternChanged: {
                            title: item.name,
                            description: item.description
                        }
                    })
                );
            });

        this.patternHeaderItem$.pipe(
            takeUntil(this.onDestroy$),
            // I introduced this line because we were getting updates here with the same value.
            // This was causing the title form to grab the focus from the user (see issue 2998)
            distinctUntilChanged(headerItemComparer) 
        ).subscribe((item) => {
            if (item == null) {
                // This handles the cases for save, discard and change current.
                this.editing = false;
            }
            this.headerItem = item ?? null;
            this.headerForm.setValue(
                {
                    name: item?.name ?? '',
                    description: item?.description ?? ''
                },
                { emitEvent: false }
            );
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes?.creating?.currentValue) {
            this.editing = true;
        }
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
    }

    onOutsideClick() {
        if (this.headerForm.valid) {
            this.editing = false;
        }
    }

    onEdit() {
        this.editing = true;
    }

    get valid(): boolean {
        return this.headerForm.valid;
    }
}
